import { OrderDetailsResponse } from '@models/response/order';
import { PrintLayout } from '@models/ropolo';
import { createSlice } from '@reduxjs/toolkit';

type bikerState = {
  sendPrint: boolean;
  order: OrderDetailsResponse | undefined;
  printerLayout: PrintLayout;
};

const initialState: bikerState = {
  sendPrint: false,
  order: undefined,
  printerLayout: PrintLayout.KITCHEN,
};

const autoPrintSlice = createSlice({
  name: 'autoPrintSlice',
  initialState,
  reducers: {
    setOrder: (state, action) => ({
      ...state,
      order: action.payload,
    }),
    setPrint: (state, action) => ({
      ...state,
      sendPrint: action.payload,
    }),
    setPrinterLayout: (state, action) => ({
      ...state,
      printerLayout: action.payload,
    }),
  },
});

export default autoPrintSlice;
